document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lp-faq').forEach(function (section) {
    section.querySelectorAll('.lp-faq__header').forEach(function (header) {
      header.addEventListener('click', function () {
        var item = header.closest('.lp-faq__item');
        var isOpen = item.classList.contains('is-open');
        var answerWrap = item.querySelector('.lp-faq__answer-wrap');

        if (isOpen) {
          answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
          requestAnimationFrame(function () {
            answerWrap.style.maxHeight = '0';
          });
          item.classList.remove('is-open');
          header.setAttribute('aria-expanded', 'false');
        } else {
          answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
          answerWrap.addEventListener('transitionend', function handler() {
            answerWrap.style.maxHeight = '';
            answerWrap.removeEventListener('transitionend', handler);
          });
          item.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Set initial max-height for first item (already has is-open class)
    section.querySelectorAll('.lp-faq__item.is-open .lp-faq__answer-wrap').forEach(function (wrap) {
      wrap.style.maxHeight = 'none';
    });
  });
});
